// extracted by mini-css-extract-plugin
export default {"modal":"BeanModal_modal__h1F-n","displayBeanFooter":"BeanModal_displayBeanFooter__5UlNe","beanImg":"BeanModal_beanImg__gL+zm","beanWrapper":"BeanModal_beanWrapper__djDrg"};